import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { designSystem, Modal, PanelGroup, Panel } from '@yola/ws-ui';
import { t } from '../localization';
import utils from '../utils';
import yousersServiceClient from '../common/helpers/yousers-service-client';

const MIN_WIDTH = 358;

const {
  DialogButton,
  DialogButtonGroup,
  DialogButtonGroupSeparator,
  Box,
  Stack,
  Paragraph,
  Heading,
  Icon,
  HorizontalStack,
} = designSystem;

const TermsOfUseDialog = ({
  termsOfUseUrl,
  privacyPolicyUrl,
  logoutUrl,
  onSubmit = Function.prototype,
  onCancel = Function.prototype,
  onOverlayClick = Function.prototype,
}) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    const yousers = yousersServiceClient.get();

    setLoading(true);

    yousers
      .acceptUserAgreement()
      .post()
      .then(onSubmit)
      .catch(onSubmit)
      .finally(() => setLoading(false));
  };

  const handleCancel = () => {
    onCancel();

    utils.redirectToUrl(logoutUrl);
  };

  const handleOverlayClick = () => onOverlayClick();

  return (
    <Modal
      overlay="visible"
      centered
      resizable={false}
      draggable={false}
      minWidth={MIN_WIDTH}
      height="auto"
      handleSubmit={handleSubmit}
      handleCancel={handleCancel}
      onOverlayClick={handleOverlayClick}
    >
      <PanelGroup height="100%">
        <Panel height="100%" style={{ borderBottom: 'none' }}>
          <Box margin="spacing-l">
            <Stack gap="spacing-xs">
              <HorizontalStack align="center">
                <Icon glyph="handshake" size={32} />
              </HorizontalStack>
              <Stack>
                <Heading type="heading-5" align="center">
                  {t('New Terms & Policies')}
                </Heading>
                <Paragraph align="center">
                  <span
                    // eslint-disable-next-line yola/react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: t(
                        'Since you last visit, we’ve made a few updates to our <a href={termsOfUseUrl} target="_blank" rel="noreferrer"><b>Terms of Service</b></a> and <a href={privacyPolicyUrl} target="_blank" rel="noreferrer"><b>Privacy Policy</b></a>. We encourage you to review all of the updated terms that apply to you',
                        { termsOfUseUrl, privacyPolicyUrl }
                      ),
                    }}
                  />
                </Paragraph>
              </Stack>
            </Stack>
          </Box>
        </Panel>
        <Panel className="ws-terms-of-use-buttons">
          <DialogButtonGroup>
            <DialogButton isLoading={loading} onClick={handleSubmit}>
              {t('Accept Terms')}
            </DialogButton>
            <DialogButtonGroupSeparator />
            <DialogButton disabled={loading} onClick={handleCancel}>
              {t('Decline & Log out')}
            </DialogButton>
          </DialogButtonGroup>
        </Panel>
      </PanelGroup>
    </Modal>
  );
};

TermsOfUseDialog.propTypes = {
  termsOfUseUrl: PropTypes.string.isRequired,
  privacyPolicyUrl: PropTypes.string.isRequired,
  logoutUrl: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  onOverlayClick: PropTypes.func,
};

export default TermsOfUseDialog;
